import React from 'react';
import cx from 'classnames';

import Card from '@marketing/components/card';
import SectionHeader from '@marketing/components/section_header';

import AIPracticeQuestionsFeature from './assets/ai_practice_questions_feature.png';
import AITutorFeature from './assets/ai_tutor_feature.png';
import SparkleBg from './assets/sparkle_bg.svg';
import SparkleIcon from './assets/sparkle_icon.svg';
import marketingStyles from '@marketing/style.module.scss';
import styles from './style.module.scss';

export default (props) => {
  return (
    <div className="d-flex flex-column gap-l u-margin-T-xl" style={{ position: 'relative' }}>
      <SparkleBackground />

      <SectionHeader
        reveal
        subtitle="Chat with an expert AI tutor, and practice similar questions with Magoosh."
        supertitle="AI test prep"
        supertitleIcon={SparkleIcon}
        title="Study smarter with AI"
      />

      <div className={cx(styles.aiFeaturesContainer, 'd-flex flex-column flex-lg-row gap-m gap-lg-l')}>
        <Card className="d-flex flex-1 flex-column gap-m">
          <div>
            <img
              alt="Examples of helpful conversations with the AI tutor"
              loading="lazy"
              src={AITutorFeature}
            />
          </div>

          <div className="d-flex flex-column gap-s">
            <div className="text-bold text-inter">
              AI Tutor
            </div>

            <div className="text-inter" style={{ fontSize: 15 }}>
              Chat with an AI expert trained on lessons and content and ready to explain whatever you don’t grasp.
            </div>
          </div>
        </Card>

        <Card className="d-flex flex-1 flex-column gap-m">
          <div>
            <img
              alt="Examples of AI-generated similar practice questions"
              loading="lazy"
              src={AIPracticeQuestionsFeature}
            />
          </div>

          <div className="d-flex flex-column gap-s">
            <div className="text-bold text-inter">
              2,000+ Similar Practice Questions
            </div>

            <div className="text-inter" style={{ fontSize: 15 }}>
              Missed a question? Get similar, high-quality AI-generated problems to practice again.
            </div>
          </div>
        </Card>
      </div>

      <div className="u-margin-T-xl">
        <SparkleBackground mirror />
      </div>
    </div>
  );
};

const SparkleBackground = ({ mirror = false }) => {
  return (
    <>
      <div
        className={marketingStyles.fullPageWidthContainerBreakout}
        style={{
          background: 'linear-gradient(to bottom, transparent, #F2E9FB 30%, #FCECF7 70%, transparent)',
          bottom: mirror ? -75 : 'initial',
          height: 300,
          position: 'absolute',
          top: mirror ? 'initial' : -75,
          zIndex: -3
        }}
      />
      <div
        style={{
          bottom: mirror ? -75 : 'initial',
          height: 300,
          position: 'absolute',
          top: mirror ? 'initial' : -75,
          transform: mirror ? 'scaleX(-1) scaleY(-1)' : '',
          width: '100%',
          zIndex: -2
        }}
      >
        <img alt="" src={SparkleBg} />
      </div>
      <div
        className={marketingStyles.fullPageWidthContainerBreakout}
        style={{
          background: 'linear-gradient(to bottom, #fff, transparent 50%, #fff)',
          bottom: mirror ? -75 : 'initial',
          height: 310,
          position: 'absolute',
          top: mirror ? 'initial' : -75,
          zIndex: -1
        }}
      />
    </>
  );
};
